<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <ul>
      <li *ngFor="let d of data">
        <strong>{{d?.number}}</strong> - {{d?.name}} - {{d?._embedded?.headquarter?.zipAndTownship}}
      </li>
    </ul>
  </div>
</div>
